export default "__VITE_ASSET__yy7vk6GS__"